<template>
  <path
    d="M16 19.0003C16 19.5503 15.55 20.0003 15 20.0003H9C8.45 20.0003 8 19.5503 8 19.0003C8 18.4503 8.45 18.0003 9 18.0003H15C15.55 18.0003 16 18.4503 16 19.0003ZM11 7.99027V15.0003C11 15.5503 11.45 16.0003 12 16.0003C12.55 16.0003 13 15.5503 13 15.0003V7.99027H14.79C15.24 7.99027 15.46 7.45027 15.14 7.14027L12.35 4.36027C12.15 4.17027 11.84 4.17027 11.64 4.36027L8.86 7.14027C8.54 7.45027 8.76 7.99027 9.21 7.99027H11Z"
  />
</template>
